import { Anchor, Text } from "@mantine/core";
import { config } from "@/config";

export function PersonalLinkPreview({
  inviteCode,
  personalLink,
}: {
  inviteCode: string;
  personalLink?: string | null;
}) {
  if (!inviteCode) return null;
  const idLink = `${config.landingRoot}/join/trainer/${inviteCode}`;
  const fullLink = personalLink ? `${idLink}/${personalLink}` : idLink;
  return (
    <div>
      <Text size="sm" c="dimmed" mb={2}>
        Preview:
      </Text>
      <Anchor
        href={fullLink}
        target="_blank"
        style={{ wordBreak: "break-word", display: "block", width: "100%" }}
      >
        {fullLink}
      </Anchor>
    </div>
  );
}
